<template lang="pug">
Loading(v-if="!loaded")
.sd(v-else)

	.ge-head_team.ge-head_team--sd_local
		img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
		span.ge-head_team__name {{ $store.state.match.localShortName }}

	.sd-table-wrap
		span.sd-table__points_tit {{ $t('Points')}}
		.sd-table-leg
			.sd-table-leg-group.sd-table-leg-group--local
				div: span +{{range}}
				div: span +{{range/1.5}}
				div: span +{{range/3}}
			span.absolute 0
			.sd-table-leg-group.sd-table-leg-group--visitor
				div: span -{{range/3}}
				div: span -{{range/1.5}}
				div: span -{{range}}
		.sd-table
			span.sd-table__period_tit {{ $t('Quarters') }}
			.sd-table-bg
				.sd-table-bg-group.sd-table-bg-group--local
					div
					div
					div
				.sd-table-bg-group.sd-table-bg-group--visitor
					div
					div
					div
			ScoreDevPeriod(
				v-for="(value, name) in scoredev"
				:key="name"
				:range="range"
				:period="name"
				:scores="value"
			)

	.ge-head_team.ge-head_team--sd_visitor
		img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
		span.ge-head_team__name {{ $store.state.match.visitorShortName }}
</template>

<style lang="sass">

.sd
	max-width: 900px
	width: 100%
	margin: 0 auto
	display: flex
	flex-direction: column
	box-sizing: border-box
	align-content: flex-start
	&__shield
		align-self: center
		&--local
			padding-bottom: 1rem
		&--visitor
			padding-top: 3rem
	&__title
		align-self: center
		padding-bottom: 4rem

	&-table
		display: flex
		width: 100%
		height: 150px
		position: relative
		&-wrap
			display: flex
			flex-direction: row
			position: relative
		&-leg
			display: flex
			flex-direction: column
			position: relative
			text-align: right
			margin-right: .5em
			span
				line-height: 1em
			.absolute
				position: absolute
				top: 50%
				transform: translateY(-50%)
				right: 0
			&-group
				flex-basis: 100%
				display: flex
				flex-direction: column
				div
					flex-basis: 100%
				&--local
					div
						transform: translateY(-50%)
						color: $local
				&--visitor
					div
						transform: translateY(50%)
						color: $visitor

		&__points_tit
			position: absolute
			font-weight: $bold
			transform: translateY(-100%)
			top: -15px

			+breakpoint(medium)
				position: initial
				transform: initial
				display: flex
				align-self: flex-end
				writing-mode: vertical-rl

				padding-right: 0.2rem

		&__period_tit
			position: absolute
			bottom: 0
			transform: translateY(100%)
			padding-top: 2.3rem
			font-weight: $bold


		&-bg
			display: flex
			flex-direction: column
			position: absolute
			width: 100%
			height: 100%
			z-index: -1
			&-group
				display: flex
				flex-basis: 100%
				flex-direction: column
				div
					flex-basis: 100%
				&--local
					div:nth-child(1)
						background: rgba($grey, 0.3)
						width: 100%
					div:nth-child(2)
						background: rgba($grey, 0.2)
						width: 100%
					div:nth-child(3)
						background: rgba($grey, 0.1)
						width: 100%
				&--visitor
					div:nth-child(1)
						background: rgba($grey, 0.1)
						width: 100%
					div:nth-child(2)
						background: rgba($grey, 0.2)
						width: 100%
					div:nth-child(3)
						background: rgba($grey, 0.3)
						width: 100%
		&-period
			position: relative
			display: flex
			flex-direction: row
			flex-basis: 100%
			border-right: 1px solid rgba($grey,0.4)
			&:nth-child(n+7)
				flex-basis: 50%
			&__legend
				padding-top: 0.5rem
				position: absolute
				bottom: 0
				transform: translateY(100%)
		&-minute
			display: flex
			flex-direction: column
			height: 100%
			width: 100%
			&-team
				flex-basis: 50%
				display: flex
				&__value
					width: 100%
				&--local
					.sd-table-minute-team__value
						background: $local
						align-self: flex-end
						transition: height 1s
				&--visitor
					.sd-table-minute-team__value
						background: $visitor
						height: 0
						transition: height 1s
</style>

<script>
import api from "@/api/index";

import ScoreDevPeriod from "@/components/subcomponents/score-dev/ScoreDevPeriod.vue";
import Loading from "@/components/subcomponents/general/Loading.vue";

export default {
  name: "ScoreDev",
  data() {
    return {
      loaded: false,
      scoredev: {}
    };
  },
  computed: {
    refreshSignal() {
      return this.$store.state.general.refreshSignal;
    },
    max_diff() {
      let max = 0;
      for (let key in this.scoredev) {
        let scoredev_abs = this.scoredev[key].map(val => Math.abs(val));
        let max_local = Math.max(...scoredev_abs);
        if (max < max_local) {
          max = max_local;
        }
      }
      return max == 0 ? 3 : max;
    },
    range() {
      return Math.ceil(this.max_diff / 3) * 3;
    }
  },
  methods: {
    updateScoreDev() {
      api.match.getMatchScoreDev(this.$route.params.id_match).then(data => {
        this.$data.scoredev = data;
        this.$data.loaded = true;
      });
    }
  },
  watch: {
    refreshSignal(newValue) {
      if (newValue) {
		if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
          this.updateScoreDev();
      }
    }
  },
  created() {
    this.updateScoreDev();
  },
  components: {
    ScoreDevPeriod,
    Loading
  }
};
</script>
